//  -*-web-*-
import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';

const buttonStyle = makeStyles({
    root: {
	'padding-top': 0,
	'padding-bottom': 0,
	'font-size': '0.9rem',
	textTransform: 'lowercase',
    }
});

export function ChartButtons(props) {
    const [value, setValue] = React.useState(props.val);
    const [radio, setRadio] = React.useState(props.radio);
    const bStyle = buttonStyle();
    if (radio === undefined) setRadio(false);
    
    // --------------------------------------------------------------------
    // Handle new value when a button is clicked by the user
    // --------------------------------------------------------------------
    const handleValue = (event, newValue) => {
	if (newValue === null && radio) {
	    setValue(value);
	    return;
	}
	setValue(newValue);
	if (props.onClick) props.onClick(props, newValue);
    };
    
    // --------------------------------------------------------------------
    // Generate a list of buttons for the button group
    // --------------------------------------------------------------------
    const itemList = props.items.map((i) =>
	<ToggleButton
	  classes={{ root: bStyle.root }}
	  key={i}
	  fontSize="small"
	  value={i}>
	{i}</ToggleButton>
    );
    
    // --------------------------------------------------------------------
    // Render the component
    // --------------------------------------------------------------------
    return (
	<Box>
	  <FormLabel p={1}>{props.label}&nbsp;</FormLabel>
	  <ToggleButtonGroup
	    value={value}
	    size="small"
	    exclusive={!props.multiselect}
	    onChange={handleValue} >
	    {itemList}
          </ToggleButtonGroup>
	</Box>
    );
}
